import { FunctionComponent } from 'react';
import { CEEmailSentModal } from 'widgets/auth/changeEmail/EmailSentModal';

export const ChangeEmailEmailSent: FunctionComponent = () => {
	return <CEEmailSentModal />;
};
